import { DtmDataLayer } from '../models/dtm-data-layer';
import { Injectable, isDevMode } from '@angular/core';
import { SelfAttendanceService } from '../shared/services/self-attendance.service';
import { Mapping } from "../shared/enum/dtm";

declare var document: any;

@Injectable({
  providedIn: 'root',
})
export class DtmService {
  private currentDataLayer: DtmDataLayer;
  private selfAttendanceService: SelfAttendanceService;

  constructor(selfAttendanceService: SelfAttendanceService) {
    this.selfAttendanceService = selfAttendanceService;
    this.currentDataLayer = new DtmDataLayer();
    document.DataLayer = JSON.parse(
      this.currentDataLayer.getFormattedDataLayer('Default')
    );
  }

  public getSessionDataLayer() {
    const dataLayer = JSON.parse((sessionStorage.getItem('dataLayer') || localStorage.getItem('dataLayer')) || '{}');

    document.DataLayer = dataLayer;
  }

  // O parametro "Mapped" pode ser informado para mapear a propriedade {{Product}}
  // para uma das classificacoes de produtos
  public pageLoaded(pageName: string, logged?: boolean, mapped?: string) {
    this.currentDataLayer.onPageLoad(pageName, document.location.href, logged, mapped);
    this.saveDtmOnSessionStorage();
  }

  public userLoaded(userData: any) {
    this.currentDataLayer.onUserLoad(userData);
    this.saveDtmOnSessionStorage();
  }

  public productsLoaded(products: Array<any>) {
    this.currentDataLayer.onProductsLoad(products);
    this.saveDtmOnSessionStorage();
  }

  public checkoutSuccess(confirmationData: any) {
    this.currentDataLayer.onCheckoutSuccess(confirmationData);
    this.saveDtmOnSessionStorage();
  }

  public customLoaded(events: Array<any>, checkout?: string, userInfo?: any, custom?: any) {
    this.currentDataLayer.onCustomLoad(events, checkout, userInfo, custom);
    this.saveDtmOnSessionStorage();
  }

  public sendPixConfirmation() {
    this.customLoaded(['PIXSuccess'], 'Sydle');
    this.getSessionDataLayer();
    this.currentDataLayer.products.confirmacao.purchaseStatus = 'PAID';
    this.saveDtmOnSessionStorage();
    this.trigger('PIXSuccess', document.DataLayer);
  }


  public ruleChange(newRule: string) {
    this.currentDataLayer.rule = newRule;
    this.saveDtmOnSessionStorage();
  }

  public customErrorLoaded(events: Array<any>, errorData: any) {
    this.currentDataLayer.onCustomErrorLoad(events, errorData);
    this.saveDtmOnSessionStorage();
    this.sendErrorEvent();
  }

  public customEventCreditCardPaymentError(events: Array<any>, errorData: any) {
    this.currentDataLayer.onCustomEventCreditCardPaymentError(events, errorData);
    this.saveDtmOnSessionStorage();
    this.sendEventCreditCardPaymentError();
  }

  public customClickEvent(clickText: string, clickSection?: string) {
    this.currentDataLayer.onClickLoad(['cliquesGenericos'], clickText, clickSection);
    this.saveDtmOnSessionStorage();
    this.sendClickEvent();
  }


  public customClickEventCancelPurchase(classificationIdentifier) {
    let product = "AutoAtendimento:" + Mapping[classificationIdentifier] + ":";
    let clickText = "";
    let clickSection = "";

    clickText = "Cancelamento";
    clickSection = "CancelarCompra";

    this.customClickEvent(product + clickText, clickSection);

  }
  public clicksModalSuggestion(suggestionProduct: string, selectedProduct: string, caseName:string){
    this.currentDataLayer.onClickSuggestionModal(selectedProduct, suggestionProduct,  caseName);
    this.saveDtmOnSessionStorage();
    this.sendClickEvent();
  }

  public customClickEventAutoRechargeChange(classificationIdentifier, productIdentifier) {
    let product = "Checkout:" + Mapping[classificationIdentifier] + ":";
    let clickText = "";
    let clickSection = "";

    clickText = "AlterarRecarga:Pacotes:" + productIdentifier;
    clickSection = "Comprar";

    this.customClickEvent(product + clickText, clickSection);

  }

  public customClickEventNewGeneric(productData) {
    let product = "Checkout:" + Mapping[productData.product.classificationIdentifier] + "";
    let classificationIdentifier = productData.product.classificationIdentifier;
    let clickText = "";
    let clickSection = "";

    if (classificationIdentifier === "consulta-e-recuperacao-de-dividas" ||
      classificationIdentifier === "monitore-clientes" ||
      classificationIdentifier === "saude-do-seu-negocio" ||
      classificationIdentifier === "plano-mensal") {

      if (classificationIdentifier === "consulta-e-recuperacao-de-dividas") {
        clickText = ":MeuPacote:PrePago:Pacotes:" + productData.product.identifier;
        clickSection = "Comprar";
      } else if (classificationIdentifier === "plano-mensal") {
        clickText = ":MeuPacote:Controle:Planos:" + productData.product.identifier;
        clickSection = "Comprar";
      } else if (classificationIdentifier === "monitore-clientes" || classificationIdentifier === "saude-do-seu-negocio") {
        clickText = ":MeuPlano:Planos:" + productData.product.identifier;
        clickSection = "AssinarAgora";
      }

      this.customClickEvent(product + clickText, clickSection);
    }

  }  

  public customCancellation(events: Array<any>, reason: string, refund?: boolean) {
    this.currentDataLayer.onCustomCancellationLoad(events, reason, refund);
    this.saveDtmOnSessionStorage();
  }

  public customRetention(events: Array<any>, reason: string) {
    this.currentDataLayer.onCustomRetentionLoad(events, reason);
    this.saveDtmOnSessionStorage();
  }

  public customNotFoundError(events: Array<any>, errorData: any) {
    this.currentDataLayer.onCustomErrorLoad(events, errorData);
    this.saveDtmOnSessionStorage();
    this.sendPageLoadEvent();
  }

  public suggestionEvent(suggestionProduct: string, selectedProduct: string){
    this.currentDataLayer.onLoadSuggestionModal(selectedProduct,suggestionProduct);

    this.saveDtmOnSessionStorage();
    this.sendPageLoadEvent();
  }
  public saveDtmOnSessionStorage() {
    sessionStorage.setItem('dataLayer', JSON.stringify(this.currentDataLayer));
    localStorage.setItem('dataLayer', JSON.stringify(this.currentDataLayer));
    this.getSessionDataLayer();
  }

  public sendPageLoadEvent(customTrigger?: string) {
    let trigger = (customTrigger && customTrigger !== "") ? customTrigger : 'CustomPageView';
    this.trigger(trigger, document.DataLayer);
  }

  sendCancellationEvent() {
    // console.log('Cancelar load: ', document.DataLayer);
    this.trigger('CancelarPlano', document.DataLayer);
  }

  sendRetentionEvent() {
    // console.log('Retencao load: ', document.DataLayer);
    this.trigger('RetencaoSucesso', document.DataLayer);
  }

  public sendErrorEvent() {
    // console.log('Error event: ',document.DataLayer);
    this.trigger('CustomError', document.DataLayer);
  }

  public sendEventCreditCardPaymentError() {
    // console.log('Error event: ',document.DataLayer);
    this.trigger('CreditCardPaymentError', document.DataLayer);
  }

  public sendClickEvent() {
    this.trigger('CliquesGenericos', document.DataLayer);
  }

  public sendPurchaseEvent() {
    this.trigger('Purchase', document.DataLayer);
  }

  public trigger(eventName: string, data?: DtmDataLayer) {
    this.pushToDataLayer(eventName, data);
    this.createAnalyticsRedundance(eventName, data);
  }

  public sendSydleCustomEvent(eventName: string, data?: any) {
    try {
      window.stag('event', "triggerAnalytics",
        {
          ...data,
          "trigger": eventName || null,
        }
      )
    } catch (e) { }
  }

  pushToDataLayer(eventName: string, data: any) {
    // O IE11 nao reconhece o construtor "new CustomEvent",
    // eh necessario criar um event do tipo CustomEvent e inicializa-lo com o initCustomEvent
    // document.dispatchEvent(new CustomEvent ( eventName, { 'detail' : data}));
    const event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, false, false, {
      detail: data,
    });

    console.log('Trigger analytics', JSON.stringify({
      'trigger': eventName,
      'data': data
    }, null, 4));

    document.dispatchEvent(event);
  }

  createAnalyticsRedundance(eventName: string, data: any) {
    const userData = data && data.userInfo ? data.userInfo : null;
    const customData = data && data.custom ? data.custom : null;

    if (!userData && !customData) return;

    const eventData = {
      "userId": userData && userData.userId ? userData.userId : null,
      "businessId": userData && userData.businessId ? userData.businessId : null,
      "analyticsJSONData": "Trigger analytics " + JSON.stringify(data, null, 4),
      "errorDetail": customData && customData.errorDetail ? customData.errorDetail : null,
      "errorMessage": customData && customData.errorMessage ? customData.errorMessage : null,
      "itemClicado": customData && customData.itemClicado ? customData.itemClicado : null,
    }

    this.sendSydleCustomEvent(eventName, eventData);
  }
}
